"use client";

import { c as _c } from "react/compiler-runtime";
import { type ReactNode, useEffect, useRef } from "react";
import { useTrackingData } from "@/contexts/tracking/tracking.context";
import { useElementViewedPercentage } from "@/hooks/tracking/in-view/use-element-viewed-percentage.hook";
import { useJpmuid } from "@/hooks/tracking/jpmuid/use-jpmuid.hook";
import { useTracking } from "@/hooks/tracking/use-tracking";
import { useAuthentication } from "@/vendors/authentication/hooks/use-authentication.hook";
import { useCookiebotConsent } from "@/vendors/Cookiebot/_hooks/use-cookiebot-consent.hook";
type ScrollTrackerProps = {
  readonly className?: string;
  readonly children: ReactNode;
  readonly roundToNearest?: number;
};
export function ScrollTracker(t0) {
  const $ = _c(13);
  const {
    children,
    className,
    roundToNearest: t1
  } = t0;
  const roundToNearest = t1 === undefined ? 25 : t1;
  const ref = useRef(null);
  const {
    emit
  } = useTracking();
  const {
    trackingData
  } = useTrackingData();
  const consent = useCookiebotConsent();
  const {
    jpmuid
  } = useJpmuid();
  const {
    user
  } = useAuthentication();
  let t2;
  if ($[0] !== roundToNearest) {
    t2 = {
      ref,
      roundToNearest
    };
    $[0] = roundToNearest;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const {
    percentageViewed
  } = useElementViewedPercentage(t2);
  let t3;
  let t4;
  if ($[2] !== consent || $[3] !== emit || $[4] !== jpmuid || $[5] !== percentageViewed || $[6] !== trackingData || $[7] !== user) {
    t3 = () => {
      if (!consent.submitted) {
        return;
      }
      emit({
        event: "scroll-depth",
        model: {
          consent,
          jpmuid,
          percentageViewed,
          trackingDataModel: trackingData,
          user
        }
      });
    };
    t4 = [emit, percentageViewed, trackingData, consent, jpmuid, user];
    $[2] = consent;
    $[3] = emit;
    $[4] = jpmuid;
    $[5] = percentageViewed;
    $[6] = trackingData;
    $[7] = user;
    $[8] = t3;
    $[9] = t4;
  } else {
    t3 = $[8];
    t4 = $[9];
  }
  useEffect(t3, t4);
  let t5;
  if ($[10] !== children || $[11] !== className) {
    t5 = <div className={className} ref={ref}>{children}</div>;
    $[10] = children;
    $[11] = className;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  return t5;
}